var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-email',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],ref:"dialogEmail",attrs:{"data":_vm.data,"contentMap":_vm.contentMap},on:{"on-submit-email":_vm.onSubmitEmail}})}
var staticRenderFns = []

export { render, staticRenderFns }